import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"

const PVHPage = ({ data }) => {
    return (
        <Layout>
            <div className="container is-fluid main-wrapper">
                <section className="section" id="BuyNow">
                    <div className="container">
                        <div className="columns is-desktop is-vcentered">
                            <div className="column is-6-desktop"><Img fluid={data.ClearsightBottle.childImageSharp.fluid} alt="Clearsight Vision Health Bottle" /></div>
                            <div className="column is-6-desktop">
                                <h2 className="title is-spaced">Clearsight Vision Health By Hightly</h2>
                                <section>
                                    <div className="container has-text-centered py-4">
                                        <div className="columns">
                                            <div className="column">
                                                <div className="card">
                                                    <div className="card-content">
                                                        <h3 className="title is-4">1 Bottle</h3>
                                                        <h4 className="title is-spaced is-5">$34.99 <br /><hr /><small>$34.99 <br />Per Bottle</small></h4>
                                                        <a className="button is-primary is-outlined" type="button" href="https://www.hightly.com/cart/31852303417409:1">Add To Cart</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="column">
                                                <div className="card">
                                                    <div className="card-content">
                                                        <h3 className="title is-4">2 Bottles</h3>
                                                        <h4 className="title is-spaced is-5">$67.92 <br /><hr /><small>$33.96 <br />Per Bottle</small></h4>
                                                        <a className="button is-primary is-outlined" href="https://www.hightly.com/cart/31852303417409:2?discount=2bottlesClearsight">Add To Cart</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="column">
                                                <div className="card">
                                                    <div className="card-content">
                                                        <h3 className="title is-4">3 Bottles</h3>
                                                        <h4 className="title is-spaced is-5">$89.97 <br /><hr /><small>$29.99 <br />Per Bottle</small></h4>
                                                        <a className="button is-primary" type="button" href="https://www.hightly.com/cart/31852303417409:3?discount=3orMoreClearsight">Add To Cart</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <hr />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <section className="section">
                <div className="container has-text-centered">
                    <h2 className="title">Let us Earn Your Trust</h2>
                    <div className="columns is-multiline">
                        <div className="column"><Img fluid={data.FastFreeShipping.childImageSharp.fluid} alt="Fast and Free Shipping" /></div>
                        <div className="column"><Img fluid={data.Guarantee.childImageSharp.fluid} alt="Money Back Guarantee" /></div>
                        <div className="column"><Img fluid={data.MadeWithLove.childImageSharp.fluid} alt="Made With Love" /></div>
                        <div className="column"><Img fluid={data.MadeInUsa.childImageSharp.fluid} alt="Made In the USA" /></div>
                    </div>
                </div>
            </section>
        </Layout>

    )


}

export default PVHPage



export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
        }
      }
    }
    ClearsightBottle: file(relativePath: {eq: "clearsightbyhightly.png"}) {
      childImageSharp {
        fluid(maxWidth: 564){
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
	
	    FastFreeShipping: file(relativePath: {eq: "FastFreeShipping.png"}) {
      childImageSharp {
        fluid(maxWidth: 200){
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
	
	Guarantee: file(relativePath: {eq: "Guarantee.png"}) {
      childImageSharp {
        fluid(maxWidth: 200){
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
	
		MadeWithLove: file(relativePath: {eq: "MadeWithLove.png"}) {
      childImageSharp {
        fluid(maxWidth: 200){
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
	
		MadeInUsa: file(relativePath: {eq: "MadeInUsa.png"}) {
      childImageSharp {
        fluid(maxWidth: 200){
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    

  }

`
